var map = {
	"./3modes.png": 2096,
	"./architecture.png": 1312,
	"./code.png": 7594,
	"./coding.png": 2047,
	"./complexstructure.png": 3758,
	"./component.png": 5732,
	"./componentesign.png": 8976,
	"./cover.png": 5140,
	"./cover0.png": 9710,
	"./cover3.png": 5461,
	"./delete.png": 7616,
	"./designprocess.png": 4316,
	"./designprocess1.png": 7804,
	"./designtesting.gif": 6796,
	"./designtesting0.gif": 812,
	"./documentation.png": 2267,
	"./documentation2.png": 2401,
	"./fdlogo.svg": 3786,
	"./icon.png": 218,
	"./plugins.png": 2489,
	"./popoverautolayout.gif": 2346,
	"./techreview.png": 7077,
	"./themeworkflow.png": 6073,
	"./tokenexample.png": 2634,
	"./tokenspec.png": 5047,
	"./training.png": 8207,
	"./visualspecdoc.png": 4772,
	"./workshop.png": 6806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1543;